import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import StatisticsContentComponent from './StatisticsContent/StatisticsContent.container';
import { withRouter } from '../../RouterCompatibility.js';

const StatisticsPage = ({ t, location }) => {
    const staticNames = t?.reportPage || {};

    return (
        <div className="dashboard dashboard_consolidated-report">
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <StatisticsContentComponent
                location={location}
            />
        </div>
    );
};

StatisticsPage.propTypes = {
    t: PropTypes.object,
    location: PropTypes.object
};

StatisticsPage.defaultProps = {
    t: {},
    location: {}
};

export default withRouter(withTranslation(StatisticsPage));